/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import Promise from 'bluebird';
import ViewModel from '@bingads-webui-campaign-legacy/adextension-associations-editor/viewmodel/index';
import layoutTemplate from '@bingads-webui-campaign-legacy/adextension-associations-editor/template/layout.pug';
import termsofServiceTemplate from '@bingads-webui-campaign-legacy/adextension-associations-editor/template/terms-of-service.pug';
import alert from '@bingads-webui-campaign-legacy/error-alert/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';
import popup from '@bingads-webui-component-legacy/dialog/popup';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import doubleListBoxBinding from '@bingads-webui-component-legacy/double-list-box/ko/doubleListBoxBinding';
import dlbDefaultLayout from '@bingads-webui-component-legacy/double-list-box/template/defaultLayout.pug';
import dlbDefaultLeanLayout from '@bingads-webui-component-legacy/double-list-box/template/defaultLeanLayout.pug';
import * as _ErrorGrid from '@bingads-webui-campaign-legacy/adextension-shared/view/error-grid';
import * as imageAdExtensionHelper from '@bingads-webui-campaign-legacy/adextension-image/util/image-adextension-helper';
import * as putils from '@bingads-webui-universal/primitive-utilities';
import * as clarity from '@bingads-webui-universal/clarity';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var ErrorGrid = _ErrorGrid.default;
var permissions = config.get('Permissions') || ({});
var odataPath = config.get('odata.url') + config.get('odata.path');
var odataRootUrl = config.get('CampaignAzureDomain');
var odataToken = config.get('odata.token');
var oDataConfig = {
  odataRootUrl: odataRootUrl,
  odataPath: odataPath,
  odataToken: odataToken
};
var defaults = {
  i18n: i18n,
  pageSize: 10,
  i18nKeys: {
    search_for: 'Searchbox_SearchFor',
    filter_watermark: 'AdExtensions_Search',
    save_btn: 'Button_Save',
    cancel_btn: 'Button_Cancel',
    subtitle: [],
    multiSelectInlineAlert: 'AdExtensions_MultiSelect_Max_Select_Notification',
    failedAssociationsLabel: 'AdExtensions_FailedAssociationsLabel',
    successfulAssociationsLabel: 'AdExtensions_SuccessfulAssociationsLabel'
  },
  template: {
    layout: layoutTemplate,
    dlbLayoutTemplate: dlbDefaultLayout,
    preview: '#:data.name#',
    rowTemplate: function () {
      return 'data.name';
    }
  },
  useNewDlbLayout: false,
  allowSelectAll: false,
  allowDeselectAll: false,
  maxSelectedItemsCount: -1,
  hasSubTitle: true,
  showErrorsInline: false,
  popupFront: '',
  extensionType: '',
  showEditor: true,
  showBoxList: true,
  isMultiSelect: false,
  entityType: 'campaign',
  showSaveBar: true,
  instrumentation: {
    startScenario: _.noop,
    startActivity: _.noop,
    logMessage: _.noop,
    endActivity: _.noop,
    asLoggingStart: _.constant(_.noop)
  },
  instrumentConstants: {
    LOGCATEGORY: {},
    LOGLEVEL: {}
  },
  instrumentationSettings: {
    ACTIVITYNAME: {},
    SCENARIONAME: {}
  },
  disableDelete: false
};
var TermsofServiceView = Backbone.View.extend({
  render: function () {
    this.$el.html(termsofServiceTemplate({
      i18n
    }));
    return this;
  },
  events: {
    'click .accept': 'accept',
    'click .cancel': 'cancel'
  },
  accept: function () {
    this.trigger('accept');
  },
  cancel: function () {
    this.trigger('cancel');
  }
});
var View = Backbone.View.extend({
  events: {
    'click .associations .btn-save': '_saveClickHandler',
    'click .associations .btn-cancel': '_cancelClickHandler',
    'click .associations .btn-create': '_createClickHandler'
  },
  idField: 'Id',
  initialize: function (options) {
    if (options && options.perfMarker) {
      this.showExtensionMarker = options.perfMarker.createChild(`Show_Extension_${options.extensionType}_${options.entityType}`);
      this.showExtensionMarker.willInit();
    }
    this.options = _.defaults({}, options, defaults);
    this.i18nKeys = _.defaults({}, this.options.i18nKeys, defaults.i18nKeys);
    this.template = _.defaults({}, this.options.template, defaults.template);
    if (this.options.useNewDlbLayout) {
      this.template.dlbLayoutTemplate = dlbDefaultLeanLayout;
    }
    this.idField = this.options.idField || this.idField;
    this.showErrorsInline = this.options.showErrorsInline;
    this.orderBy = this.options.orderBy;
    this.i18nKeys.subtitle = _.isArray(this.i18nKeys.subtitle) ? this.i18nKeys.subtitle : [this.i18nKeys.subtitle];
    this.options.data.association.createRequestFactory(this.options.entityType);
    this.itemActions = this.itemActions || ({});
    this.itemActions.source = _.defaults(this.itemActions.source || ({}), {
      'edit': {
        caption: '',
        callback: _.bind(this._editExtension, this),
        class: 'glyphicon glyphicon-pencil',
        label: i18n.get('Edit')
      },
      'delete': {
        caption: '',
        callback: _.bind(this._deleteExtension, this),
        class: 'glyphicon glyphicon-remove',
        label: i18n.get('Remove')
      }
    });
    this.itemActions.selected = _.defaults(this.itemActions.selected || ({}), {
      'edit': {
        caption: '',
        callback: _.bind(this._editExtension, this),
        class: 'glyphicon glyphicon-pencil',
        label: i18n.get('Edit')
      },
      'delete': {
        caption: '',
        callback: _.bind(this._deleteExtension, this),
        class: 'glyphicon glyphicon-remove',
        label: i18n.get('Remove')
      }
    });
    if (this.options.disableDelete) {
      if (this.itemActions.source.delete) {
        delete this.itemActions.source.delete;
      }
      if (this.itemActions.selected.delete) {
        delete this.itemActions.selected.delete;
      }
    }
    this.subtitleArgs = {
      'maxLimit': options.maxSelectedItemsCount,
      'entityType': options.entityType === 'campaign' ? i18n.get('AdExtension_EntityName_Campaign').toLowerCase() : i18n.get('AdExtension_EntityName_AdGroup').toLowerCase()
    };
    this.ko_model = new ViewModel(_.extend(_.pick(this.options, 'pageSize', 'filterField', 'entityType', 'processItem', 'headerText', 'showEditor', 'showBoxList', 'i18n', 'maxSelectedItemsCount', 'allowSelectAll', 'allowDeselectAll', 'processSelectedOptions', 'processSourceOptions'), {
      i18nKeys: this.i18nKeys,
      allExtensions: _.bind(this._loadSource, this),
      dlbLayoutTemplate: this.template.dlbLayoutTemplate,
      itemTemplateType: this.template.previewTemplateType,
      itemTemplate: this.template.preview,
      itemActions: this.itemActions,
      idField: this.idField,
      campaignId: (this.options.isStringFormatId ? this.options.campaignId : Number(this.options.campaignId)) || 0,
      adgroupId: (this.options.isStringFormatId ? this.options.adgroupId : Number(this.options.adgroupId)) || 0,
      campaignName: this.options.campaignName || '',
      adGroupName: this.options.adGroupName || '',
      getMaximumSelectionAlertString: this._getMaximumSelectionAlertString.bind(this)
    }));
    this.ko_model.isAssociationChanged.subscribe((function (changed) {
      this.trigger('selected-changed', changed);
    }).bind(this));
    this.debouncedUpdateMultiAssetWarningMessage = _.debounce(this._updateMultiAssetWarningMessage, 100, false);
    this.ko_model.selectedExtensions.subscribe((function () {
      if (this.options.extensionType === 'ImageExtension') {
        this.debouncedUpdateMultiAssetWarningMessage();
      }
    }).bind(this));
    this.on('associate:extensions', this._saveClickHandler);
    this.findScope = this.options.findScope || this.defaultFindScope;
    return this;
  },
  logActivityToSubstrate: function (message) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, 'adextension associations editor');
    }
  },
  defaultFindScope: function (association) {
    return function (scope) {
      return scope.campaignId === association.CampaignId && scope.adGroupId === association.AdGroupId;
    };
  },
  render: function () {
    this.$el.html(this.template.layout({
      i18n: this.options.i18n,
      i18nKeys: this.i18nKeys,
      hasSubTitle: this.options.hasSubTitle,
      showErrorsInline: this.showErrorsInline,
      subtitleArgs: this.subtitleArgs,
      showSaveBar: this.options.showSaveBar,
      showSaveButtonAsDefaultButton: this.options.showSaveButtonAsDefaultButton
    }));
    ko.applyBindings(this.ko_model, this.$el[0]);
    this.on('scope-changed', this.onScopeChange.bind(this));
    this.on('scopes-changed', this.onScopesChange.bind(this));
    if (!this.options.isMultiSelect || !this.options.showSelector) {
      this._selectScope(this.ko_model.scope());
    }
    if (!!this.options.adExtensionId) {
      this._editExtensionById(this.options.adExtensionId);
    }
    return this;
  },
  onScopeChange: function (scope) {
    this.ko_model.scope(scope);
    this.ko_model.updateInlineAlertString();
    this._selectScope(scope);
  },
  onScopesChange: function (scopes) {
    this.ko_model.scopes(scopes);
    this.ko_model.clearOriginalIds();
  },
  remove: function () {
    this.undelegateEvents();
    this.$el.empty();
    ko.cleanNode(this.$el[0]);
    if (this.editor) {
      this.editor.remove();
    }
    return this;
  },
  _updateMultiAssetWarningMessage: function () {
    var imageExtensions = this.ko_model.selectedExtensions();
    if (imageAdExtensionHelper.default.isAssociationsQualifyForMultiAsset(imageExtensions)) {
      this.ko_model.shouldShowMultiAssetWarning(false);
    } else {
      this.ko_model.shouldShowMultiAssetWarning(true);
    }
  },
  _getMaximumSelectionAlertString: function (campaignName, adgroupName) {
    var entityName = adgroupName || campaignName;
    if (this.options.maxSelectedItemsCount > 0) {
      if (this.options.isMultiSelect) {
        return i18n.get(this.i18nKeys.multiSelectInlineAlert, {
          count: this.options.maxSelectedItemsCount
        });
      } else if (this.i18nKeys.inlineAlert) {
        if (_.isString(entityName) && entityName.length > 0) {
          return i18n.get(this.i18nKeys.inlineAlert, {
            name: entityName,
            count: this.options.maxSelectedItemsCount
          });
        } else {
          return i18n.get(this.i18nKeys.multiSelectInlineAlert, {
            count: this.options.maxSelectedItemsCount
          });
        }
      }
    }
    return '';
  },
  _loadSource: function (request, cb) {
    if (this.showExtensionMarker) {
      this.showExtensionMarker.willFetchData();
    }
    this._clearErrors();
    var params = {
      where: {
        name: {
          contains: request.filterText
        }
      },
      skip: request.skip,
      limit: request.take
    };
    if (this.orderBy) {
      params.orderBy = this.orderBy;
    }
    this.options.data.extension.findAll(params).then((function (data) {
      if (this.showExtensionMarker) {
        this.showExtensionMarker.willRender();
      }
      cb(null, data);
      if (this.showExtensionMarker) {
        this.showExtensionMarker.done();
      }
    }).bind(this)).finally(withUiBlock(this.$el)).catch((function (error) {
      this._handleErrors(error);
      cb(error);
    }).bind(this));
  },
  _selectScope: function (scope) {
    this._clearErrors();
    if (scope.campaignId || scope.adGroupId || this.options.entityType === 'account') {
      this.ko_model.setLoadedSelection([]);
      this.options.data.association.findAll({
        where: scope,
        associationType: this.options.associationType
      }).then((function (associated) {
        this.ko_model.setLoadedSelection(associated);
      }).bind(this)).finally(withUiBlock(this.$el)).catch((function (error) {
        this._handleErrors(error);
      }).bind(this));
    }
  },
  _deleteExtension: function (extension) {
    if (popup.confirm(i18n.get(this.i18nKeys.delete_confirm))) {
      this._clearErrors();
      this.options.data.extension.destroy(extension[this.idField]).finally(withUiBlock(this.$el)).then((function () {
        this.ko_model.handleDelete(extension);
        this.trigger('deleted', extension);
        if (this.options.extensionType !== '') {
          this.options.instrumentation.logMessage([this.options.instrumentConstants.LOGCATEGORY.TRACE], this.options.instrumentConstants.LOGLEVEL.INFO, 'delete' + this.options.extensionType, '1');
        }
      }).bind(this)).catch((function (error) {
        this._handleErrors(error);
      }).bind(this));
      this.trigger('extensions:changed');
      if (permissions.IsTransparentImageAnnotationEnabled && this.options.extensionType === 'ImageExtension' && extension.SourceType === 'SystemGenerated') {
        const survey = _.get(window, 'survey');
        clarity.setClarityTag({
          TransparentImageAnnotationDeleteAdExtension: true
        });
        if (survey && survey.surveyManager && _.isFunction(survey.surveyManager.trigger)) {
          survey['TransparentImageAnnotationSurveyTrigger'] = true;
          window.survey.TransparentImageAnnotationCustomParams = {
            AdExtensionIds: [extension.Id]
          };
          survey.surveyManager.trigger();
        }
      }
    }
  },
  _showInfoExtension: function (extension) {},
  _editExtensionById: function (extensionId) {
    this.options.data.extension.find(extensionId).finally(withUiBlock(this.$el)).then(this._editExtension.bind(this)).catch(this._handleErrors.bind(this));
  },
  _handleCreatedExtension: function (ext) {
    this.ko_model.handleCreate(ext);
    this.editor.remove();
    this.trigger('created', ext);
    this.trigger('close:extensionEditor');
    if (this.options.extensionType !== '') {
      this.options.instrumentation.logMessage([this.options.instrumentConstants.LOGCATEGORY.TRACE], this.options.instrumentConstants.LOGLEVEL.INFO, 'create' + this.options.extensionType, '1');
    }
    this.trigger('extensions:changed');
    if (this.options.extensionType === 'ImageExtension') {
      this.debouncedUpdateMultiAssetWarningMessage();
    }
  },
  _handleUpdatedExtension: function (ext) {
    this.ko_model.handleUpdate(ext);
    this.editor.remove();
    this.trigger('updated', ext);
    this.trigger('close:extensionEditor');
    if (this.options.extensionType !== '') {
      this.options.instrumentation.logMessage([this.options.instrumentConstants.LOGCATEGORY.TRACE], this.options.instrumentConstants.LOGLEVEL.INFO, 'update' + this.options.extensionType, '1');
    }
    this.trigger('extensions:changed');
    if (this.options.extensionType === 'ImageExtension') {
      this.debouncedUpdateMultiAssetWarningMessage();
    }
  },
  _handleCancel: function () {
    this.editor.remove();
    this.trigger('close:extensionEditor');
    this.logActivityToSubstrate(`click ${this.options.extensionType} cancel button`);
  },
  _handleRemove: function () {
    this.trigger('close:extensionEditor');
    this.editor = null;
  },
  _editExtension: function (extension) {
    if (!!this.editor) {
      this.editor.remove();
    }
    this._clearErrors();
    if (this.options.extensionType === 'LogoAdExtension') {
      this.logActivityToSubstrate('click add-logo-extension button');
    }
    if (!extension && this.options.extensionType === 'LeadFormExtension' && permissions.dynamic.LeadFormAdExtension) {
      this.logActivityToSubstrate('click add-lead-form-extension button');
      const TermsofServiceDialogView = dialogDecorator.decorate(TermsofServiceView, {
        position: 'center',
        popupFront: '.navbar-fixed-top',
        maxHeight: '70%'
      });
      const termsOfServicePopup = new TermsofServiceDialogView({}).render();
      termsOfServicePopup.on('accept', () => {
        termsOfServicePopup.remove();
        this._showEditPopup(extension);
        this.logActivityToSubstrate('accept terms of service');
      });
      termsOfServicePopup.on('cancel', () => {
        termsOfServicePopup.remove();
        this.logActivityToSubstrate('cancel terms of service');
      });
    } else {
      this._showEditPopup(extension);
    }
  },
  _showEditPopup(extension) {
    var EditorCtor = !!extension ? this.options.EditForm : this.options.CreateForm;
    if (this.options && this.options.perfMarker) {
      var action = !!extension ? 'Edit' : 'Create';
      this.AddEditExtensionMarker = this.options.perfMarker.createChild(`${action}_Extension_${this.options.extensionType}_${this.options.entityType}`);
      this.AddEditExtensionMarker.willInit();
    }
    if (this.options.extensionType === 'ImageExtension') {
      this.trigger('modeChange', {
        isEdit: !!extension
      });
    }
    this.editor = new EditorCtor(_.extend({
      extension: extension,
      data: this.options.data,
      campaignId: this.options.campaignId,
      adgroupId: this.options.adgroupId,
      title: i18n.get(!!extension ? this.i18nKeys.edit_title : this.i18nKeys.create_title),
      i18nKeys: this.i18nKeys,
      dialogOptions: {
        popupFront: this.options.popupFront
      },
      instrumentation: this.options.instrumentation,
      instrumentationSettings: this.options.instrumentationSettings,
      disableScheduling: this.options.disableScheduling,
      isForVNext: this.options.isForVNext,
      oDataConfig: oDataConfig,
      newI18n: this.options.newI18n,
      editorPerfMarker: this.AddEditExtensionMarker
    }, this.options.extraEditorOptions, this.options.usePanel ? {
      eventsToActions: [{
        event: 'created',
        action: (function (ext) {
          this._handleCreatedExtension(ext);
        }).bind(this)
      }, {
        event: 'updated',
        action: (function (ext) {
          this._handleUpdatedExtension(ext);
        }).bind(this)
      }, {
        event: 'cancel',
        action: this._handleCancel.bind(this)
      }, {
        event: 'remove',
        action: this._handleRemove.bind(this)
      }],
      onClose: (function (e) {
        if (e.currentTarget.className === 'react-focus-lock' && e.type === 'keyup' || e.currentTarget.className === 'panel-mask' || e.currentTarget.className && e.currentTarget.className.indexOf('panel-close') > -1) {
          this._handleCancel();
        }
      }).bind(this)
    } : {})).render();
    if (!this.options.usePanel) {
      this.editor.on('created', (function (ext) {
        this._handleCreatedExtension(ext);
      }).bind(this));
      this.editor.on('updated', (function (ext) {
        this._handleUpdatedExtension(ext);
      }).bind(this));
      this.editor.on('cancel', this._handleCancel.bind(this));
      this.editor.on('remove', this._handleRemove.bind(this));
    }
    if (this.AddEditExtensionMarker) {
      this.AddEditExtensionMarker.done();
    }
    this.trigger('open:extensionEditor');
  },
  _createClickHandler: function () {
    this._editExtension(null);
  },
  _removeAssociations: function (changes, scope) {
    return this.options.data.association.destroyAll({
      where: _.extend({
        id: {
          'in': changes.removed
        }
      }, scope)
    }).then(this.ko_model.handleRemovedIds.bind(this.ko_model, changes.removed));
  },
  _createAssociations: function (changes, scope, scopes, cb) {
    var updatedIds = {
      id: {
        'in': changes.added
      }
    };
    if (this.options.isMultiSelect) {
      return this.options.data.association.updateAll(null, {
        where: updatedIds
      }, scopes);
    } else {
      return this.options.data.association.updateAll(null, {
        where: _.extend(updatedIds, scope)
      });
    }
  },
  _saveClickHandler: function (event) {
    this._clearErrors();
    var changes = this.ko_model.changes(), scope = this.ko_model.scope(), scopes = this.ko_model.scopes();
    if (!changes.isEmpty) {
      var updateAssociationsActivity = scopes.length > 1 ? this.options.instrumentationSettings.ACTIVITYNAME.UpdateAssociationsForMultipleEntities : this.options.instrumentationSettings.ACTIVITYNAME.UpdateAssociationsForSingleEntity;
      this.options.instrumentation.startScenario(this.options.instrumentationSettings.SCENARIONAME.UpdateAdExtensionAssociations);
      this.options.instrumentation.startActivity(updateAssociationsActivity);
      this._removeAssociations(changes, scope).then(this._createAssociations.bind(this, changes, scope, scopes)).bind(this).finally(withUiBlock(this.$el)).then(this.ko_model.handleSave.bind(this.ko_model)).then(function () {
        var removedCount = _.size(changes.removed);
        var addedCount = _.size(changes.added);
        if (removedCount > 0) {
          this.options.instrumentation.logMessage([this.options.instrumentConstants.LOGCATEGORY.TRACE], this.options.instrumentConstants.LOGLEVEL.INFO, 'AdExtension/DeleteAssociations', JSON.stringify({
            extensionCount: removedCount,
            extensionType: this.options.extensionType,
            entityType: this.options.entityType,
            entityCount: _.size(scopes) || 1
          }));
          this.logActivityToSubstrate('adextension removed. extensionType: ' + this.options.extensionType + ' extensionCount: ' + removedCount);
        }
        if (addedCount > 0) {
          this.options.instrumentation.logMessage([this.options.instrumentConstants.LOGCATEGORY.TRACE], this.options.instrumentConstants.LOGLEVEL.INFO, 'AdExtension/CreateAssociations', JSON.stringify({
            extensionCount: addedCount,
            extensionType: this.options.extensionType,
            entityType: this.options.entityType,
            entityCount: _.size(scopes) || 1
          }));
          this.logActivityToSubstrate('adextension added. extensionType: ' + this.options.extensionType + ' extensionCount: ' + addedCount);
        }
        this.options.instrumentation.endActivity(updateAssociationsActivity);
        this.trigger('save', this.ko_model.selectedExtensions());
        this.trigger('save:success', this.ko_model.selectedExtensions());
      }).catch(function (errors) {
        this._handleErrors(errors);
      }).finally(function () {
        this.options.instrumentation.startActivity(this.options.instrumentationSettings.ACTIVITYNAME.SaveAdExtensionAssociations);
      });
    } else {
      this.trigger('save', this.ko_model.selectedExtensions());
    }
  },
  _cancelClickHandler: function () {
    this._clearErrors();
    this.trigger('cancel');
  },
  _clearErrors: function () {
    this.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    if (!this.showErrorsInline) {
      alert.clearErrorSummary();
    }
  },
  _processOdataErrors: function (errors, response) {
    var propertyName = _.constant('message')();
    var errTemplate = putils.curlyTemplate('<a href={{url}}>{{message}}</a>');
    return _.chain(errors).map(function (error, index) {
      var source = response.errors[index];
      return {
        type: source['@odata.type'],
        message: source.Message ? errTemplate({
          url: source.Message,
          message: error.toString()
        }) : error.toString()
      };
    }).groupBy('type').mapObject(function (val) {
      return _.uniq(val, false, propertyName);
    }).map(function (val, key) {
      if (key === '#Model.ApiEditorialError') {
        return i18n.get('Editorial_Error_Alert', {
          message: _.pluck(val, propertyName).join(', ')
        });
      }
      return _.pluck(val, propertyName);
    }).flatten().value();
  },
  _handleErrors: function (response) {
    var errorMessages = i18nErrors.getODataErrors(response.errors);
    if (response.associations && this.options.isMultiSelect) {
      var associationErrors = _.filter(errorMessages, function (err) {
        return !!response.associations.value[err.property] && !(err.Message == null && err.code == 'EditorialError');
      });
      errorMessages = _.difference(errorMessages, associationErrors);
      this._handleAssociationErrors(associationErrors, response.associations);
    }
    if (!errorMessages.length && !response.errorResponseBody) {
      return;
    }
    if (this.showErrorsInline) {
      this.ko_model.errors.add(errorMessages);
    } else {
      if (response.type === 'odata') {
        errorMessages = this._processOdataErrors(errorMessages, response);
      } else if (response.errorResponseBody && response.errorResponseBody.Errors) {
        errorMessages = _.uniq(response.errorResponseBody.Errors, false, 'Code');
      }
      alert.showJsonErrors(errorMessages);
    }
  },
  _handleAssociationErrors: function (errorMessages, associations) {
    errorMessages = _.chain(errorMessages).groupBy('property').map(function (errors) {
      return _.uniq(errors, 'message');
    }).flatten().value();
    var associationErrors = _.map(errorMessages, (function (error) {
      var association = associations.value[error.property];
      var scope = _.find(this.ko_model.scopes(), this.findScope(association));
      var extension = _.find(this.ko_model.selectedExtensions(), function (ext) {
        return ext.Id == association.AdExtensionId;
      });
      return {
        Entity: {
          campaignName: scope && scope.campaignName ? scope.campaignName : '',
          adgroupName: scope && scope.adGroupName ? scope.adGroupName : ''
        },
        Extension: extension,
        Error: error.message
      };
    }).bind(this));
    if (associationErrors.length) {
      this._createErrorGrid(associationErrors);
      this.ko_model.failedAssociationsLabel(i18n.get(this.i18nKeys.failedAssociationsLabel, {
        count: associations.failCount
      }));
      this.ko_model.successfulAssociationsLabel(i18n.get(this.i18nKeys.successfulAssociationsLabel, {
        count: associations.successCount
      }));
    } else {
      _.result(this.errorGrid, 'removeGrid');
      this.ko_model.failedAssociationsLabel('');
    }
  },
  _createErrorGrid: function (errors) {
    this.errorGrid = new ErrorGrid({
      rowTemplate: this.template.rowTemplate,
      el: this.$('.error-grid-container'),
      errors: errors,
      entityType: this.options.entityType,
      i18nKeys: this.options.i18nKeys
    }).render();
  }
});
export default View;

